import $ from 'jquery';

window.navigation_hooked = true;
window.navigation_in_progress = false;
window.flip = function(){
    console.log('flipped');
    return navigation_hooked = !navigation_hooked;
}

window.custom_navigation = async function(url){
    let container = $('#new-body')
    let uploading = $('#upload-banner.state-uploading')[0]

    if (!uploading) {
        window.dispatchEvent(new CustomEvent('banner-hide'))
    }

    let response = await fetch(url, { Headers: {'nolayout': 'true'} });
    let response_text = await response.text()
    let doc = document.createElement('html')
    doc.innerHTML = response_text;
    let body = $('section.primary-content', doc)
    let nav = $('nav', doc)
    let nav_html = nav.html()
    let topbar = $('#topbar', doc)
    nav.remove()

    $('#upload-status').hide()

    nav_container.html(nav_html)
    let primary_container = $('section.primary-content')
    if (primary_container[0] && !uploading) {
        primary_container.html(body.html())
    } else {
        container.html(body.html())
        container.show()
    }
    $('#topbar').html(topbar.html())
    $(".navbar").removeClass("show-sidebar");

    hooks();

    history.pushState({}, '', url)
    console.log('[navigation] complete.', url)
    setTimeout(function(){
        $('#assign-form select').select2()
        hooks();
    },500)
}

let menu_open = false
let clicking = false;
let user_display_click = function(evt){
    if (clicking) { return; }
    clicking = true;

    console.log('[data-toggle=dropdown] clicked', evt)
    let target = $(evt.target)

    let container = target.closest('.btn-group')
    if (!container) {
        container = target.closest('.btn')
    }
    let menu = container.find('.dropdown-menu')
    console.log('[nav] dropdown clicked', menu);

    menu.data('open', !menu.data('open'))

    if (menu.data('open')) {
        if (menu_open) {
            menu_open.hide()
        }
        menu_open = menu
        menu.show()
    } else {
        menu.hide()
    }

    setTimeout(function(){ clicking = false; console.log('clicking finished') }, 300);
    //target.toggle('dropdown')
}

let user_display_close = function(evt){
        let target = $(evt.target)
        let menu = $(target).closest('.dropdown-menu')
        menu && menu.hide();
        evt.preventDefault();
}

window.tab_hasher = function() {
    var hash = window.location.hash.replace("#", '');
    if (hash && hash.length > 0) {
        var tab_pages = $('.tab-page')
        var $tab = tab_pages.filter(function(i){ return $(tab_pages[i]).data('name') == hash; })
        console.log("Setting hash", hash)
        if ($tab) {
            $('.tab-page.active').addClass('hidden')
            $('.tab-page.active').removeClass('active')
            $tab.removeClass('hidden')
            $tab.addClass('active')
            var target_button = $('.tab-btn').filter(function(i){
                let tab = $('.tab-btn')[i]
                let t = $(tab).data('target')
                console.log('tabt', tab, t, hash)
                return t == hash;
            });
            console.log('target_button', target_button)
            if (target_button.length > 0) {
                target_button.parent().find('.tab-btn.active').removeClass('active')
                target_button.addClass('active')
            }
        }
    }
};

let hooks = function(){
    //$('[data-toggle=dropdown]').unbind('click')
    $('.user-display-btn').click(user_display_click)

    //$('.close-dropdown').unbind('click')
    $('.user-display .close-dropdown').click(user_display_close);
    $('a').unbind('click')
    $('a').on('click', async function(evt){
        let $target = $(evt.target)
        if ($target.attr('@click')) {
            console.log('[navigation] skipping due to @click defined')
            return;
        }

        if ($target.is('button')) {
            console.log('[navigation] skipping due to being a Button')
            return;
        }

        if (!navigation_hooked) { return };
        if (navigation_in_progress) {
            evt.preventDefault();
            return;
        }

        let el = evt.target
        let link = $(el).closest('a')
        let url = link.attr('href')

        if (link.data('toggle') != 'dropdown' && menu_open) {
            menu_open.hide && menu_open.hide()
        }

        if (link.data('external-link') || (url && url.indexOf('imdb.com') >= 0)) {
            return;
        }

        console.log('[navigation] link detected', evt.target)

        if (link[0]) {
            evt.preventDefault()
            let upload_in_progress = $('#upload-banner.state-uploading')[0]
            window.dispatchEvent(new CustomEvent('banner-show'))

            if (link.data('show-upload-status') && upload_in_progress) {
                $('#new-body').hide();
                $('#upload-status').show();
            } else {
                await custom_navigation(url);
            }
        }
    });

    $('button').click(function(evt){
        if (evt.currentTarget.classList.contains('select2-selection__choice__remove')) return;
        if (evt.currentTarget.parentElement.classList.contains('drp-buttons')) return; // date range picker buttons
        let form = $(evt.target).closest('form')[0]
        if (form && form.classList.contains('avoid-js-submit')) return;
        let signup = false
        let el = evt.target
        let link = $(el).closest('button')
        try {
            if (form && form.action.indexOf('signup') < 0) {
                signup = true
                console.log('signup page detected')
            }
        } catch (e) {
            console.error('signup page detection failed')
        }

        signup = false

        if (form && !signup) {
            console.log("[button] form found - submitting")
            if (form.checkValidity()){
                form.submit()
                evt.preventDefault()
            }
        } else {
            console.log('[button] event.preventDefault()')
            evt.preventDefault();
            evt.stopImmediatePropagation();

            if(link.data('is-sidebar-button') === true || link.data('is-sidebar-button') === "true"){
              if($(".navbar").hasClass("show-sidebar")){
                $(".navbar").removeClass("show-sidebar");
              }else{
                $(".navbar").addClass("show-sidebar");
              }
            }
        }
    });

    let tab_btns = $('.tab-btn')
    tab_btns.unbind('click')
    tab_btns.click(function(evt){
        evt.preventDefault()
        let $btn = $(evt.target)

        if ($btn.hasClass('active')) {
            return;
        }

        let container_name = $btn.data('target-container')
        let container = $(`#${container_name}`)
        let target_name = $btn.data('target')
        let tab_pages = $('.tab-page');

        if (container.length > 0 && container.data('reset-top') === "true") {
            console.log('[tab] reset-top detected on container')
            window.scrollTo(0,0)
        }

        $btn.parent().find('.active').removeClass('active')
        $btn.addClass('active')

        let $target = $(tab_pages.filter(function(e){
            let $el = $(tab_pages[e]);
            let name = $el.data('name');
            console.log('tab-page', name, e, $el);
            return name === target_name;
        })[0]);

        if ($target.length > 0) {

            let pages = $('.tab-page', container)
            console.log('[tab] target found', $target[0])
            pages.removeClass('active')
            pages.addClass('hidden')

            $target.removeClass('hidden')
            window.location.hash = target_name
        } else {
            console.error('[tab] target not found', target_name, tab_pages.length)
        }

    });

    tab_hasher()
    setTimeout(tab_hasher, 0);

    window._rails_loaded = false
    window.rails_ujs.start()
}

window.hooks = hooks

$(document).ready(function(){
    window.nav_container = $('nav')
    tab_hasher()
    setTimeout(function(){
        $('#assign-form select').select2()
        hooks();
    },500)

    hooks();
});


let items = document.querySelectorAll('.carousel .carousel-item')

		items.forEach((el) => {
			const minPerSlide = 4
			let next = el.nextElementSibling
			for (var i=1; i<minPerSlide; i++) {
				if (!next) {
            // wrap carousel by using first child
            next = items[0]
        }
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
    }
})
